import {
  UpdateEmployeesInput,
  UpdateEmployeesMutation,
  useMutationNotifier,
  useOrgEmployeeListQuery,
  useUpdateEmployeesMutation,
} from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { useOrgId } from '../useOrgId'

type UseUpdateEmployeesMutationOptions = UseGqlMutationCallbacks<
  UpdateEmployeesMutation,
  Pick<UpdateEmployeesInput, 'role'>
>
export const useUpdateEmployees = (
  employeeIds: Array<number>,
  mutationOptions?: UseUpdateEmployeesMutationOptions
) => {
  const optionsWithNotifs = useMutationNotifier({}, mutationOptions)
  const optionsWithInvalidation = useMutationOptionsWithInvalidation(optionsWithNotifs, [
    useOrgEmployeeListQuery.getKey({ orgId: useOrgId() }),
  ])
  const { mutateAsync } = useUpdateEmployeesMutation()
  return useMutation((attributes) => mutateAsync({ employeeIds, ...attributes }), optionsWithInvalidation)
}
